import { useMemo } from "react";
import { useLocalSearchParams } from "expo-router";

export type AuditLogFilter = {
  type?: string;
  model_type?: string;
  user_id?: string;
};

export function useAuditLogFilterParams() {
  const params = useLocalSearchParams();

  const filteredParams = useMemo(() => {
    const filter: AuditLogFilter = {};
    ["type", "model_type", "user_id"].forEach((key) => {
      if (
        params[key] &&
        typeof params[key] === "string" &&
        params[key] !== "undefined" &&
        params[key] !== ""
      ) {
        filter[key as keyof AuditLogFilter] = params[key] as string;
      }
    });
    return filter;
  }, [params]);

  return filteredParams;
}
